import {get} from "lodash"
import BaseService from "./Base"

class LeadsService extends BaseService {
    async downloadLeadsAPIDocumentationPdf(): Promise<{url: string; filename: string}> {
        const response = await this.axios.request({method: "get", url: "/v1/leads/create/docs", responseType: "blob"})

        const blob = new Blob([response.data])
        let filename = "leads-api-documentation.pdf"

        // Try to extract filename from Content-Disposition header
        const contentDisposition = response.headers["content-disposition"]
        if (contentDisposition && contentDisposition.includes("filename=")) {
            filename = contentDisposition.split("filename=")[1].replace(/['"]/g, "").trim()
        }

        const url = window.URL.createObjectURL(blob)

        return {url, filename}
    }
}

export default LeadsService
